import { faker } from '@faker-js/faker'
import {ISite, ISiteLocale} from '../../interface/organization'

export const mockOrganization = (props?: any) => ({
  id: faker.word.sample(),
  erpId: faker.word.sample(),
  name: faker.word.sample(),
  additionalInformation: faker.word.sample(),
  contactName: faker.word.sample(),
  contactPhoneNumber: faker.word.sample(),
  contactEmailAddress: faker.word.sample(),
  addressLine1: faker.word.sample(),
  addressLine2: faker.word.sample(),
  addressLine3: faker.word.sample(),
  city: faker.word.sample(),
  postCode: faker.word.sample(),
  registrationNumber: faker.word.sample(),
  vatRegistrationNumber: faker.word.sample(),
  version: faker.word.sample(),
  createdAt: faker.word.sample(),
  modifiedAt: faker.word.sample(),
  status: 'ACTIVE',
  ...props,
})

export const mockOrganizations = () => {
  return {
    data: {
      content: Array.apply(null, Array(10)).map(() => mockOrganization()),
      totalElements: 10
    },
  }
}

export const mockSite = (): ISite => {
  return {
    id: faker.string.sample(),
    erpId: faker.string.sample(),
    name: faker.string.sample(),
    status: faker.string.sample(),
    createdAt: faker.string.sample(),
    modifiedAt: faker.string.sample(),
    organizationId: faker.string.sample(),
    url: faker.string.sample(),
    version: faker.number.int(),
  }
}

export const mockSites = () => {
  return {
    data: {
      content: Array.apply(null, Array(10)).map(() => mockSite()),
      totalElements: 10
    },
  }
}

export const mockSiteLocale = (): ISiteLocale => {
  return {
    id: faker.string.sample(),
    erpId: faker.string.sample(),
    name: faker.string.sample(),
    status: faker.string.sample(),
    createdAt: faker.string.sample(),
    modifiedAt: faker.string.sample(),
    localeId: faker.string.sample(),
    siteId: faker.string.sample(),
    platformId: faker.string.sample(),
    url: faker.string.sample(),
    version: faker.number.int(),
  }
}

export const mockSiteLocales = () => {
  return {
    data: {
      content: Array.apply(null, Array(10)).map(() => mockSiteLocale()),
      totalElements: 10,
    },
  }
}
